export default "__VITE_ASSET__$3yODFKD__"